import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './permission'
import './styles/element-variables.scss'
import App from './App'

Vue.use(ElementUI, {size: 'small'})
Vue.config.productionTip = false
import configs from './config'
import '@/directives'
// 接入sentry日志告警
// import * as Sentry from "@sentry/vue"; 
// import { Integrations } from "@sentry/tracing";
// Sentry.init({
// 	Vue,
// 	dsn: "https://ba3485aa75294537956549c34ee4aceb@sentry.motie.cn//11",
// 	integrations: [
// 	  new Integrations.BrowserTracing({
// 		routingInstrumentation: Sentry.vueRouterInstrumentation(router),
// 		tracingOrigins: ["web-author-qa.pnx.laikan.com/", "author.motie.com", "author.laikan.com",/^\//],
// 	  }),
// 	],
// 	tracesSampleRate: 1.0,
//   }); 
Vue.use(configs)
import Icon from 'vue-awesome'
import levelbar from '@/views/layout/Levelbar'
import pagination from '@/views/components/pagination'
import textareaSize from '@/views/components/textareaSize'
import mutiSelect from '@/views/components/mutiSelect'
import mutiTag from '@/views/components/mutiTag'

Vue.component('icon', Icon)
Vue.component('levelbar', levelbar)
Vue.component('pagination', pagination)
Vue.component('textareaSize', textareaSize)
Vue.component('mutiSelect', mutiSelect)
Vue.component('mutiTag', mutiTag)

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js